import React from 'react';
//import "react-big-calendar/lib/css/react-big-calendar.css";
//import './collapsableContent.css'
// Setup the localizer by providing the moment (or globalize, or Luxon) Object
// to the correct localizer.

interface CollapsibleContentProps
{
    title: string,
    startingIsCollapsed: boolean,
    children: any
}

const CollapsibleContent = (props: CollapsibleContentProps) =>
{

    const [isCollapsed, setIsCollapsed] = React.useState<boolean>(props.startingIsCollapsed);

    const handleClick = () => setIsCollapsed(!isCollapsed);

    const buttonText = isCollapsed ? " ▼ ": " - ";

    return <div className={isCollapsed ? "colPanel-collapsed" : "colPanel-expanded"}>
        <div className={isCollapsed ? "colPanel-header-collapsed" : "colPanel-header-expanded"} onClick={handleClick}>
            <p className="colPanel-title">{props.title}</p>
            <p className="colPanel-icon">{buttonText}</p>
        </div>
        {!isCollapsed && <div><main className="colPanel-content">{props.children}</main></div>}
    </div>

}

export default CollapsibleContent;
